import * as React from 'react';
import { Box, Grid, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Modal, Typography } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};



const GetTimeFormat = (time) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    hours = Math.floor(time / 3600);
    minutes = Math.floor((time - (hours * 3600)) / 60);
    seconds = time - (hours * 3600) - (minutes * 60);

    if (hours == 0) {
        hours = '';
    }
    else {
        hours = hours + ' H ';
    }


    if (minutes == 0) {
        minutes = '';
    }
    else {
        minutes = minutes + ' M ';
    }

    if (seconds == 0) {
        seconds = '';
    }
    else {
        seconds = seconds + ' S ';
    }


    let final_time = hours + minutes + seconds;

    if (final_time == '') {
        final_time = 0
    }

    return final_time;
}

export const DashboardDateWiseComp = (props) => {
    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchStartDate')} label="Start Date" value={dayjs(props.mystate.txtSearchStartDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtSearchEndDate')} label="End Date" value={dayjs(props.mystate.txtSearchEndDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>







                    <Grid md={2}>
                        <Box textAlign={'end'}>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.CustomSearch()}><SearchIcon></SearchIcon></Button>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.Reload()}><CachedIcon></CachedIcon></Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getLeadsCount === false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)' }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                key={'SrNo'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'Sr. No'}
                                            </TableCell>
                                            <TableCell
                                                key={'Date'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Date'}
                                            </TableCell>


                                            <TableCell
                                                key={'LG'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'LG'}
                                            </TableCell>
                                            <TableCell
                                                key={'LP'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'LP'}
                                            </TableCell>
                                            <TableCell
                                                key={'TS'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'TS'}
                                            </TableCell>
                                            <TableCell
                                                key={'TD'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'TD'}
                                            </TableCell>
                                            <TableCell
                                                key={'ID'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'ID'}
                                            </TableCell>
                                            <TableCell
                                                key={'SD'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'SD'}
                                            </TableCell>
                                            <TableCell
                                                key={'RD'}
                                                align={'left'}
                                                style={{}}
                                                className='table-head-cell'
                                            >
                                                {'RD'}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.mystate.leadsCountData.length > 0 ?
                                            props.mystate.leadsCountData.map((item, i) => (

                                                <TableRow hover tabIndex={-1} key={i}>
                                                    <TableCell key={i} align={'left'}>
                                                        {i + 1}
                                                    </TableCell>
                                                    <TableCell key={item.source + i} align={'left'}>
                                                        {item.source !== undefined && item.source !== null && item.source !== '' ? item.source : 'Others'}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.LG == 0 ? null : props.GetLeadList(item.source, 'LG')} style = { item.LG == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.LG + i} align={'left'}>
                                                        {item.LG}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.LP == 0 ? null : props.GetLeadList(item.source, 'LP')} style = { item.LP == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.LP + i} align={'left'}>
                                                        {item.LP}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.TS == 0 ? null : props.GetLeadList(item.source, 'TS')} style = { item.TS == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.TS + i} align={'left'}>
                                                        {item.TS}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.TD == 0 ? null : props.GetLeadList(item.source, 'TD')} style = { item.TD == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.TD + i} align={'left'}>
                                                        {item.TD}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.ID == 0 ? null : props.GetLeadList(item.source, 'ID')} style = { item.ID == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.ID + i} align={'left'}>
                                                        {item.ID}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.SD == 0 ? null : props.GetLeadList(item.source, 'SD')} style = { item.SD == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.SD + i} align={'left'}>
                                                        {item.SD}
                                                    </TableCell>
                                                    <TableCell onClick={() => item.RD == 0 ? null : props.GetLeadList(item.source, 'RD')} style = { item.RD == 0 ? null : { color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} key={item.RD + i} align={'left'}>
                                                        {item.RD}
                                                    </TableCell>


                                                </TableRow>

                                            ))
                                            :
                                            "No Record Found"
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        :
                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>

            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={props.mystate.showAlert} autoHideDuration={2000} onClose={() => { props.handleCloseAlert() }}>
                <Alert
                    onClose={() => { props.handleCloseAlert() }}
                    severity={'error'}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>


            <Modal
                open={props.mystate.openLeadListModal}
                onClose={() => props.ToggleLeadsListModal()}
                // onClose={(event, reason) => {
                //     // ❌ Prevent close when clicking backdrop
                //     if (reason === "backdropClick") return;
                //     props.ToggleLeadsListModal()
                // }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-Interaction"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Lead List
                    </Typography>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        key={'SrNo'}
                                        align={'left'}
                                        style={{}}
                                        className='table-head-cell'
                                    >
                                        {'Sr. No'}
                                    </TableCell>
                                    <TableCell
                                        key={'Lead Date'}
                                        align={'left'}
                                        style={{ minWidth: 170 }}
                                        className='table-head-cell'
                                    >
                                        {'Lead Date'}
                                    </TableCell>
                                    <TableCell
                                        key={'User Details'}
                                        align={'left'}
                                        style={{}}
                                        className='table-head-cell'
                                    >
                                        {'User Details'}
                                    </TableCell>
                                    <TableCell
                                        key={'Source'}
                                        align={'left'}
                                        style={{}}
                                        className='table-head-cell'
                                    >
                                        {'Source'}
                                    </TableCell>
                                    <TableCell
                                        key={'Stage'}
                                        align={'left'}
                                        style={{}}
                                        className='table-head-cell'
                                    >
                                        {'Stage'}
                                    </TableCell>
                                    <TableCell
                                        key={'Owner'}
                                        align={'left'}
                                        style={{}}
                                        className='table-head-cell'
                                    >
                                        {'Owner'}
                                    </TableCell>
                                   

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.mystate.leadListData.length > 0 ?
                                    props.mystate.leadListData.map((item, i) => (

                                        <TableRow hover tabIndex={-1} key={i}>
                                            <TableCell key={i} align={'left'}>
                                                {i + 1}
                                            </TableCell>
                                            <TableCell align={'left'}>
                                                {item.lead_date}
                                            </TableCell>
                                            <TableCell align={'left'}>
                                                {item.user_name}
                                                <br></br>
                                                ({item.user_mobile})
                                            </TableCell>
                                            <TableCell align={'left'}>
                                                {item.lead_source}
                                            </TableCell>
                                            <TableCell align={'left'}>
                                                {item.lead_status}
                                            </TableCell>
                                            <TableCell align={'left'}>
                                                {item.lead_owner}
                                                <br></br>
                                                ({item.lead_dept})
                                            </TableCell>


                                        </TableRow>

                                    ))
                                    :
                                    "No Record Found"
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>










                </Box>
            </Modal>
        </Box>


    );
}